import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import apiClient from "../api/apiClient";
import Select from "react-select";


const PlanifLines = () => {
    const [orders, setOrders] = useState([]);
    const [filteredOrders, setFilteredOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [recepDate, setRecepDate] = useState("");
    const [serviceType, setserviceType] = useState("");
    const [project, setproject] = useState("");
    const [servicesType, setServicesType] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [projects, setProjects] = useState([]);
    const [start_route, setStartRoute] = useState("");
    const [end_route, setEndRoute] = useState("");
    const [message, setMessage] = useState("");

     // Obtener la lista de artículos desde el backend
    const fetchItems = async () => {
        try {
            const responsePro = await apiClient.get("/sales-orders/projects");
            
            // Valores estáticos
            const staticItems = [
                { value: "DES", label: "Desayuno" },
                { value: "ALM", label: "Almuerzo" },
                { value: "MER", label: "Merienda" },
                { value: "CEN", label: "Cena" },
                { value: "LIM", label: "LIMPIEZA" },
                { value: "UTE", label: "UTENSILIOS" },
                { value: "EQU", label: "EQUIPAMIENTOS" },
            ];
            setServicesType(staticItems);

            if (!Array.isArray(responsePro.data)) {
                throw new Error("Los datos recibidos no son un array");
            }
            // Formatear los Proyectos para el select
            const formattedProjects = responsePro.data.map((item) => ({
                value: item.PrjCode,
                label: `${item.PrjName}`,
            }));
            setProjects(formattedProjects);

        } catch (err) {
            console.error("Error obteniendo artículos", err);
            setError("Error al obtener los artículos.");
        }
    };

    // Función para obtener datos desde el backend
    const fetchInsumos = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get("/planif/insumos", {
                params: { startDate, endDate, project: project?.value || "", servicio: serviceType?.value || "",  start_route, end_route, recepDate }
            });

            console.log("Datos recibidos:", response.data);

            if (!Array.isArray(response.data)) {
                throw new Error("Los datos recibidos no son un array");
            }

            // Aplicar agrupación según la opción seleccionada
            const groupedData = response.data.reduce((acc, order) => {
                let key;
                    key = `${order.Almacen}`;


                if (!acc[key]) {
                    acc[key] = {
                        Project: order.Project,
                        Whs: order.Almacen,
                        Periodo: order.DiasPeriodo,
                        Dias: order.Raciones,
                        Orders: [],
                    };
                }
                acc[key].Orders.push(order);
                return acc;
            }, {});

            const formattedData = Object.values(groupedData);
            setOrders(formattedData);
            setFilteredOrders(formattedData);
            setLoading(false);
        } catch (err) {
            console.error("Error fetching orders", err);
            setError("Error al obtener órdenes de ventas.");
        }
    };
    
    // 🔍 Filtrado dinámico
    useEffect(() => {
        fetchItems();
        if (!searchTerm) {
            setFilteredOrders(orders);
            return;
        }

        const filteredData = orders.filter((order) =>
            (order.CardName ? order.CardName.toLowerCase() : "").includes(searchTerm.toLowerCase()) || 
            (order.Name ? order.Name.toLowerCase() : "").includes(searchTerm.toLowerCase())
        );

        setFilteredOrders(filteredData);
    }, [searchTerm, orders]);

    // Componente expandible para mostrar líneas de orden
    const ExpandedComponent = ({ data }) => (
        <div className="p-2">
            <h6 style={{ fontSize: "12px" }}>Detalles de la Orden</h6>
            <table className="table table-sm table-bordered" style={{ fontSize: "10px" }}>
                <thead>
                    <tr>
                        <th>Insumo</th>
                        <th>Descripción</th>
                        <th>Cantidad a Planificar</th>
                        <th>Cantidad Real</th>
                        <th>Fecha Necesaria</th>
                    </tr>
                </thead>
                <tbody>
                    {data.Orders.map((order, index) => (
                        <tr key={index}>
                            <td>{order.ItemCode}</td>
                            <td>{order.ItemName}</td>
                            <td>{order.Necesidad}</td>
                            <td>{order.NecesidadReal}</td>
                            <td>{order.FechaServicio}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const columns = [
        {
            name: "Proyecto",
            selector: (row) => row.Project,
            sortable: true,
            width: "300px",
        },
        {
            name: "Centro de Distribución",
            selector: (row) => row.Whs,
            sortable: true,
            width: "300px",
        },
        {
            name: "Dias por Periodo",
            selector: (row) => row.Periodo,
            sortable: true,
            width: "300px",
        },
        {
            name: "Raciones por Dia",
            selector: (row) => row.Dias,
            sortable: true,
            width: "300px",
        },
    ];

    // 📌 Función para generar JSON con la estructura correcta
    const generateJSON = () => {
        const payload = filteredOrders.map(order => ({
            "U_Raciones": order.Dias,
            "Series": 117,
            "Comments": `${order.Project}, Rutas: ${start_route} al ${end_route}`,
            "U_Ruteo": end_route,
            "U_Serv": serviceType?.value || "",
            "U_InicioTras": startDate || "",
            "U_FinTras": endDate || "",
            "DocumentLines": order.Orders.map(line => ({
                "ItemCode": line.ItemCode,
                "Quantity": line.Necesidad,
                "WarehouseCode": order.Whs,
                "U_Necesidad_Real": line.NecesidadReal,
                "ProjectCode": line.Project,
                "RequiredDate": line.FechaServicio,
                "U_FechaCarga": line.FechaServicio,
            }))
        }));
        return payload;
    };

    // 📌 Enviar JSON al backend
    const sendDataToBackend = async () => {
        const payload = generateJSON();
        console.log(payload);
        try {
            const response = await apiClient.post("/planif/insumos", { insumos: payload }, { timeout: 600000 });
            // Procesar la respuesta
                const results = response.data?.results || response.data || [];
                const successCount = results.filter(r => r.status === "success").length;
                const warningCount = results.filter(r => r.status === "warning").length;
                const errorCount = results.filter(r => r.status === "error").length;

                let messageText = "";
                if (successCount > 0) {
                    messageText += `${successCount} Planificaciones con éxito.\n`;
                }
                if (warningCount > 0) {
                    messageText += `${warningCount} Planificaciones sin cambios.\n`;
                }
                if (errorCount > 0) {
                    messageText += `${errorCount} errores en la planificación.\n`;
                }

                setMessage(messageText);
                if (messageText) alert(messageText);
                setError("");
                // 🔹 Limpiar los campos después del envío exitoso
                setserviceType("");     // Limpia el campo de texto
                setproject("");     // Limpia el campo de proyecto
                setFilteredOrders([]); // Borra la tabla de datos

        } catch (error) {
            console.error("Error al enviar los datos", error);
            alert("Error al enviar la solicitud.");
        }
    };

    return (
        <div className="container mt-4">
            <h2>Planificación de Insumos</h2>

            {error && <div className="alert alert-danger">{error}</div>}
            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Inicial:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Fecha Final:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                
                {/* Campo de Artículo Actual con lista desplegable con búsqueda */}
                <div className="col-md-3">
                    <label>Tipo de Servicio:</label>
                    <Select
                        options={servicesType}
                        value={serviceType}
                        onChange={setserviceType}
                        placeholder="Seleccione un Servicio..."
                        isSearchable={true}
                    />
                </div>
                <div className="col-md-3">
                    <label>Código de Proyecto:</label>
                    <Select
                        options={projects}
                        value={project}
                        onChange={setproject}
                        placeholder="Seleccione un proyecto..."
                        isSearchable={true}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label>Fecha Recepción:</label>
                    <input
                        type="date"
                        className="form-control"
                        value={recepDate}
                        onChange={(e) => setRecepDate(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Ruta Inicial:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={start_route}
                        onChange={(e) => setStartRoute(e.target.value)}
                    />
                </div>
                <div className="col-md-3">
                    <label>Ruta Final:</label>
                    <input
                        type="number"
                        className="form-control"
                        value={end_route}
                        onChange={(e) => setEndRoute(e.target.value)}
                    />
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={fetchInsumos}>Planificar</button>
            <button className="btn btn-primary mt-2 ml-2" onClick={sendDataToBackend} disabled={loading || !setOrders} > {loading ? "Generando..." : "Migrar a SAP"}</button>
            <DataTable
                columns={columns}
                data={filteredOrders}
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                pagination
            />
        </div>
    );
};

export default PlanifLines;
